interface Country {
    name: string;
    iso: string;
    cc: string;
}

const countries: readonly Country[] = [
    { name: 'Afghanistan', iso: '004', cc: '93' },
    { name: 'Albania', iso: '008', cc: '355' },
    { name: 'Antarktis', iso: '010', cc: '672' },
    { name: 'Algerie', iso: '012', cc: '213' },
    { name: 'Amerikansk Samoa', iso: '016', cc: '1-684' },
    { name: 'Andorra', iso: '020', cc: '376' },
    { name: 'Angola', iso: '024', cc: '244' },
    { name: 'Antigua og Barbuda', iso: '028', cc: '1-268' },
    { name: 'Aserbajdsjan', iso: '031', cc: '994' },
    { name: 'Argentina', iso: '032', cc: '54' },
    { name: 'Australia', iso: '036', cc: '61' },
    { name: 'Østerrike', iso: '040', cc: '43' },
    { name: 'Bahamas', iso: '044', cc: '1-242' },
    { name: 'Bahrain', iso: '048', cc: '973' },
    { name: 'Bangladesh', iso: '050', cc: '880' },
    { name: 'Armenia', iso: '051', cc: '374' },
    { name: 'Barbados', iso: '052', cc: '1-246' },
    { name: 'Belgia', iso: '056', cc: '32' },
    { name: 'Bermuda', iso: '060', cc: '1-441' },
    { name: 'Bhutan', iso: '064', cc: '975' },
    { name: 'Bolivia', iso: '068', cc: '591' },
    { name: 'Bosnia-Hercegovina', iso: '070', cc: '387' },
    { name: 'Botswana', iso: '072', cc: '267' },
    { name: 'Brasil', iso: '076', cc: '55' },
    { name: 'Belize', iso: '084', cc: '501' },
    { name: 'Det britiske territoriet i Indiahavet', iso: '086', cc: '246' },
    { name: 'Salomonøyene', iso: '090', cc: '677' },
    { name: 'De britiske Jomfruøyer', iso: '092', cc: '1-284' },
    { name: 'Brunei', iso: '096', cc: '673' },
    { name: 'Bulgaria', iso: '100', cc: '359' },
    { name: 'Myanmar', iso: '104', cc: '95' },
    { name: 'Burundi', iso: '108', cc: '257' },
    { name: 'Belarus', iso: '112', cc: '375' },
    { name: 'Kambodsja', iso: '116', cc: '855' },
    { name: 'Kamerun', iso: '120', cc: '237' },
    { name: 'Canada', iso: '124', cc: '1' },
    { name: 'Kapp Verde', iso: '132', cc: '238' },
    { name: 'Caymanøyene', iso: '136', cc: '1-345' },
    { name: 'Den sentralafrikanske republikk', iso: '140', cc: '236' },
    { name: 'Sri Lanka', iso: '144', cc: '94' },
    { name: 'Tsjad', iso: '148', cc: '235' },
    { name: 'Chile', iso: '152', cc: '56' },
    { name: 'Kina', iso: '156', cc: '86' },
    { name: 'Taiwan', iso: '158', cc: '886' },
    { name: 'Christmasøya', iso: '162', cc: '61' },
    { name: 'Kokosøyene', iso: '166', cc: '61' },
    { name: 'Colombia', iso: '170', cc: '57' },
    { name: 'Komorene', iso: '174', cc: '269' },
    { name: 'Mayotte', iso: '175', cc: '262' },
    { name: 'Republikken Kongo', iso: '178', cc: '242' },
    { name: 'Den demokratiske republikken Kongo', iso: '180', cc: '243' },
    { name: 'Cookøyene', iso: '184', cc: '682' },
    { name: 'Costa Rica', iso: '188', cc: '506' },
    { name: 'Kroatia', iso: '191', cc: '385' },
    { name: 'Cuba', iso: '192', cc: '53' },
    { name: 'Kypros', iso: '196', cc: '357' },
    { name: 'Tsjekkia', iso: '203', cc: '420' },
    { name: 'Benin', iso: '204', cc: '229' },
    { name: 'Danmark', iso: '208', cc: '45' },
    { name: 'Dominica', iso: '212', cc: '1-767' },
    { name: 'Den dominikanske republikk', iso: '214', cc: '1-809' },
    { name: 'Ecuador', iso: '218', cc: '593' },
    { name: 'El Salvador', iso: '222', cc: '503' },
    { name: 'Ekvatorial-Guinea', iso: '226', cc: '240' },
    { name: 'Etiopia', iso: '231', cc: '251' },
    { name: 'Eritrea', iso: '232', cc: '291' },
    { name: 'Estland', iso: '233', cc: '372' },
    { name: 'Færøyene', iso: '234', cc: '298' },
    { name: 'Falklandsøyene', iso: '238', cc: '500' },
    { name: 'Sør-Georgia og Sør-Sandwichøyene', iso: '239', cc: '500' },
    { name: 'Fiji', iso: '242', cc: '679' },
    { name: 'Finland', iso: '246', cc: '358' },
    { name: 'Åland', iso: '248', cc: '358' },
    { name: 'Frankrike', iso: '250', cc: '33' },
    { name: 'Fransk Guyana', iso: '254', cc: '594' },
    { name: 'Fransk Polynesia', iso: '258', cc: '689' },
    { name: 'De franske sørterritorier', iso: '260', cc: '262' },
    { name: 'Djibouti', iso: '262', cc: '253' },
    { name: 'Gabon', iso: '266', cc: '241' },
    { name: 'Georgia', iso: '268', cc: '995' },
    { name: 'Gambia', iso: '270', cc: '220' },
    { name: 'De palestinske territoriene', iso: '275', cc: '970' },
    { name: 'Tyskland', iso: '276', cc: '49' },
    { name: 'Ghana', iso: '288', cc: '233' },
    { name: 'Gibraltar', iso: '292', cc: '350' },
    { name: 'Kiribati', iso: '296', cc: '686' },
    { name: 'Hellas', iso: '300', cc: '30' },
    { name: 'Grønland', iso: '304', cc: '299' },
    { name: 'Grenada', iso: '308', cc: '1-473' },
    { name: 'Guadeloupe', iso: '312', cc: '590' },
    { name: 'Guam', iso: '316', cc: '1-671' },
    { name: 'Guatemala', iso: '320', cc: '502' },
    { name: 'Guinea', iso: '324', cc: '224' },
    { name: 'Guyana', iso: '328', cc: '592' },
    { name: 'Haiti', iso: '332', cc: '509' },
    { name: 'Heard- og McDonaldøyene', iso: '334', cc: '672' },
    { name: 'Vatikanstaten', iso: '336', cc: '379' },
    { name: 'Honduras', iso: '340', cc: '504' },
    { name: 'Hongkong', iso: '344', cc: '852' },
    { name: 'Ungarn', iso: '348', cc: '36' },
    { name: 'Island', iso: '352', cc: '354' },
    { name: 'India', iso: '356', cc: '91' },
    { name: 'Indonesia', iso: '360', cc: '62' },
    { name: 'Iran', iso: '364', cc: '98' },
    { name: 'Irak', iso: '368', cc: '964' },
    { name: 'Irland', iso: '372', cc: '353' },
    { name: 'Israel', iso: '376', cc: '972' },
    { name: 'Italia', iso: '380', cc: '39' },
    { name: 'Elfenbenskysten', iso: '384', cc: '225' },
    { name: 'Jamaica', iso: '388', cc: '1-876' },
    { name: 'Japan', iso: '392', cc: '81' },
    { name: 'Kasakhstan', iso: '398', cc: '7' },
    { name: 'Jordan', iso: '400', cc: '962' },
    { name: 'Kenya', iso: '404', cc: '254' },
    { name: 'Nord-Korea', iso: '408', cc: '850' },
    { name: 'Sør-Korea', iso: '410', cc: '82' },
    { name: 'Kuwait', iso: '414', cc: '965' },
    { name: 'Kirgisistan', iso: '417', cc: '996' },
    { name: 'Laos', iso: '418', cc: '856' },
    { name: 'Libanon', iso: '422', cc: '961' },
    { name: 'Lesotho', iso: '426', cc: '266' },
    { name: 'Latvia', iso: '428', cc: '371' },
    { name: 'Liberia', iso: '430', cc: '231' },
    { name: 'Libya', iso: '434', cc: '218' },
    { name: 'Liechtenstein', iso: '438', cc: '423' },
    { name: 'Litauen', iso: '440', cc: '370' },
    { name: 'Luxembourg', iso: '442', cc: '352' },
    { name: 'Macao', iso: '446', cc: '853' },
    { name: 'Madagaskar', iso: '450', cc: '261' },
    { name: 'Malawi', iso: '454', cc: '265' },
    { name: 'Malaysia', iso: '458', cc: '60' },
    { name: 'Maldivene', iso: '462', cc: '960' },
    { name: 'Mali', iso: '466', cc: '223' },
    { name: 'Malta', iso: '470', cc: '356' },
    { name: 'Martinique', iso: '474', cc: '596' },
    { name: 'Mauritania', iso: '478', cc: '222' },
    { name: 'Mauritius', iso: '480', cc: '230' },
    { name: 'Mexico', iso: '484', cc: '52' },
    { name: 'Monaco', iso: '492', cc: '377' },
    { name: 'Mongolia', iso: '496', cc: '976' },
    { name: 'Moldova', iso: '498', cc: '373' },
    { name: 'Montenegro', iso: '499', cc: '382' },
    { name: 'Montserrat', iso: '500', cc: '1-664' },
    { name: 'Marokko', iso: '504', cc: '212' },
    { name: 'Mosambik', iso: '508', cc: '258' },
    { name: 'Oman', iso: '512', cc: '968' },
    { name: 'Namibia', iso: '516', cc: '264' },
    { name: 'Nauru', iso: '520', cc: '674' },
    { name: 'Nepal', iso: '524', cc: '977' },
    { name: 'Nederland', iso: '528', cc: '31' },
    { name: 'Curaçao', iso: '531', cc: '' },
    { name: 'Aruba', iso: '533', cc: '297' },
    { name: 'Sint Maarten', iso: '534', cc: '' },
    { name: 'Bonaire, Sint Eustatius og Saba', iso: '535', cc: '' },
    { name: 'Ny-Caledonia', iso: '540', cc: '687' },
    { name: 'Vanuatu', iso: '548', cc: '678' },
    { name: 'Ny-Zealand', iso: '554', cc: '64' },
    { name: 'Nicaragua', iso: '558', cc: '505' },
    { name: 'Niger', iso: '562', cc: '227' },
    { name: 'Nigeria', iso: '566', cc: '234' },
    { name: 'Niue', iso: '570', cc: '683' },
    { name: 'Norfolkøya', iso: '574', cc: '672' },
    { name: 'Norge', iso: '578', cc: '47' },
    { name: 'Nord-Marianene', iso: '580', cc: '1-670' },
    { name: 'USAs ytre småøyer', iso: '581', cc: '1' },
    { name: 'Mikronesiaføderasjonen', iso: '583', cc: '691' },
    { name: 'Marshalløyene', iso: '584', cc: '692' },
    { name: 'Palau', iso: '585', cc: '680' },
    { name: 'Pakistan', iso: '586', cc: '92' },
    { name: 'Panama', iso: '591', cc: '507' },
    { name: 'Papua Ny-Guinea', iso: '598', cc: '675' },
    { name: 'Paraguay', iso: '600', cc: '595' },
    { name: 'Peru', iso: '604', cc: '51' },
    { name: 'Filippinene', iso: '608', cc: '63' },
    { name: 'Pitcairnøyene', iso: '612', cc: '870' },
    { name: 'Polen', iso: '616', cc: '48' },
    { name: 'Portugal', iso: '620', cc: '351' },
    { name: 'Guinea-Bissau', iso: '624', cc: '245' },
    { name: 'Øst-Timor', iso: '626', cc: '670' },
    { name: 'Puerto Rico', iso: '630', cc: '1' },
    { name: 'Qatar', iso: '634', cc: '974' },
    { name: 'Réunion', iso: '638', cc: '262' },
    { name: 'Romania', iso: '642', cc: '40' },
    { name: 'Russland', iso: '643', cc: '7' },
    { name: 'Rwanda', iso: '646', cc: '250' },
    { name: 'Saint-Barthélemy', iso: '652', cc: '590' },
    { name: 'St. Helena, Ascension og Tristan da Cunha', iso: '654', cc: '290' },
    { name: 'Saint Kitts og Nevis', iso: '659', cc: '1-869' },
    { name: 'Anguilla', iso: '660', cc: '1-264' },
    { name: 'Saint Lucia', iso: '662', cc: '1-758' },
    { name: 'Saint-Martin', iso: '663', cc: '590' },
    { name: 'Saint-Pierre og Miquelon', iso: '666', cc: '508' },
    { name: 'Saint Vincent og Grenadinene', iso: '670', cc: '1-784' },
    { name: 'San Marino', iso: '674', cc: '378' },
    { name: 'São Tomé og Príncipe', iso: '678', cc: '239' },
    { name: 'Saudi-Arabia', iso: '682', cc: '966' },
    { name: 'Senegal', iso: '686', cc: '221' },
    { name: 'Serbia', iso: '688', cc: '381' },
    { name: 'Seychellene', iso: '690', cc: '248' },
    { name: 'Sierra Leone', iso: '694', cc: '232' },
    { name: 'Singapore', iso: '702', cc: '65' },
    { name: 'Slovakia', iso: '703', cc: '421' },
    { name: 'Vietnam', iso: '704', cc: '84' },
    { name: 'Slovenia', iso: '705', cc: '386' },
    { name: 'Somalia', iso: '706', cc: '252' },
    { name: 'Sør-Afrika', iso: '710', cc: '27' },
    { name: 'Zimbabwe', iso: '716', cc: '263' },
    { name: 'Spania', iso: '724', cc: '34' },
    { name: 'Sudan', iso: '728', cc: '249' },
    { name: 'Sør-Sudan', iso: '729', cc: '211' },
    { name: 'Vest-Sahara', iso: '732', cc: '212' },
    { name: 'Surinam', iso: '740', cc: '597' },
    { name: 'Svalbard og Jan Mayen', iso: '744', cc: '47' },
    { name: 'Swaziland', iso: '748', cc: '268' },
    { name: 'Sverige', iso: '752', cc: '46' },
    { name: 'Sveits', iso: '756', cc: '41' },
    { name: 'Syria', iso: '760', cc: '963' },
    { name: 'Tadsjikistan', iso: '762', cc: '992' },
    { name: 'Thailand', iso: '764', cc: '66' },
    { name: 'Togo', iso: '768', cc: '228' },
    { name: 'Tokelau', iso: '772', cc: '690' },
    { name: 'Tonga', iso: '776', cc: '676' },
    { name: 'Trinidad og Tobago', iso: '780', cc: '1-868' },
    { name: 'De forente arabiske emirater', iso: '784', cc: '971' },
    { name: 'Tunisia', iso: '788', cc: '216' },
    { name: 'Tyrkia', iso: '792', cc: '90' },
    { name: 'Turkmenistan', iso: '795', cc: '993' },
    { name: 'Turks- og Caicosøyene', iso: '796', cc: '1-649' },
    { name: 'Tuvalu', iso: '798', cc: '688' },
    { name: 'Uganda', iso: '800', cc: '256' },
    { name: 'Ukraina', iso: '804', cc: '380' },
    { name: 'Makedonia', iso: '807', cc: '389' },
    { name: 'Egypt', iso: '818', cc: '20' },
    { name: 'Storbritannia', iso: '826', cc: '44' },
    { name: 'Guernsey', iso: '831', cc: '44' },
    { name: 'Jersey', iso: '832', cc: '44' },
    { name: 'Man', iso: '833', cc: '44' },
    { name: 'Tanzania', iso: '834', cc: '255' },
    { name: 'USA', iso: '840', cc: '1' },
    { name: 'De amerikanske Jomfruøyer', iso: '850', cc: '1-340' },
    { name: 'Burkina Faso', iso: '854', cc: '226' },
    { name: 'Uruguay', iso: '858', cc: '598' },
    { name: 'Usbekistan', iso: '860', cc: '998' },
    { name: 'Venezuela', iso: '862', cc: '58' },
    { name: 'Wallis- og Futunaøyene', iso: '876', cc: '681' },
    { name: 'Samoa', iso: '882', cc: '685' },
    { name: 'Jemen', iso: '887', cc: '967' },
    { name: 'Zambia', iso: '894', cc: '260' },
];

export const sortedUniqueCountryCodes = Array.from(new Set(countries.map((country) => country.cc)))
    .filter((cc) => cc !== '')
    .sort((a, b) => {
        // Check if 'cc' contains a dash
        const aHasDash = a.includes('-');
        const bHasDash = b.includes('-');

        // If 'a' has a dash and 'b' doesn't, 'a' should come after 'b'
        if (aHasDash && !bHasDash) return 1;

        // If 'b' has a dash and 'a' doesn't, 'b' should come after 'a'
        if (bHasDash && !aHasDash) return -1;

        // If both 'a' and 'b' have a dash or both don't have a dash, sort numerically
        // For 'cc' with a dash, sort based on the numeric part after the dash
        const aNumber = aHasDash ? Number(a.split('-')[1]) : Number(a);
        const bNumber = bHasDash ? Number(b.split('-')[1]) : Number(b);

        return aNumber - bNumber;
    });
